<template>
  <div :class="['tab', selected === index ? 'tab--selected' : '', disabled ? 'tab--disabled' : '']">
    <div @click="createRipple($event); changeTab(index)">{{ label }}</div>
  </div>
</template>

<script>
import helperMethods from '@/helpers/utility.js'

export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: ''
    },
    selected: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      interval: false
    }
  },
  methods: {
    changeTab (index) {
      this.$emit('tabChanged', index)
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.tab {
  @include font('content--md', $white, 0.6);
  display: flex;
  align-items: center;
  border-bottom: 2px solid rgba($blue, 0);
  text-transform: uppercase;
  user-select: none;
  cursor: pointer;
  transition: border-color 0.2s ease-out;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.6);
  }

  &:hover:not(.tab--selected):not(.tab--disabled) {
    border-bottom-color: rgba($white, 0.7);
  }

  div {
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0.5rem 1rem;
  }

  &--selected {
    border-bottom-color: $blue;
    color: $white;
  }

  &--disabled {
    color: rgba($white, 0.2);
  }
}

.tab--selected.tab--disabled {
  border-bottom-color: rgba($white, 0.3) !important;
}

</style>
